import type { Segment } from "@gui-creator/gemeinsam";

type Zeichen = { z: string; s: Segment };

function zuSegmenten(zeichen: Zeichen[]): Segment[] {
  const aus: { quelle: Segment; teil: Segment }[] = [];
  for (const { z, s } of zeichen) {
    const letzte = aus.at(-1);
    if (letzte?.quelle === s) letzte.teil.text += z;
    else aus.push({ quelle: s, teil: { ...s, text: z } });
  }
  return aus.map((x) => x.teil);
}

/** Bricht Zeilen an Leerzeichen um, sobald sie breiter als `max` Spielpixel würden. */
export function umbrechen(zeilen: Segment[][], vorschub: (z: string, fett: boolean) => number, max: number): Segment[][] {
  const aus: Segment[][] = [];
  for (const zeile of zeilen) {
    const zeichen: Zeichen[] = zeile.flatMap((s) => [...s.text].map((z) => ({ z, s })));
    let start = 0;
    let breite = 0;
    let leer = -1;
    for (let i = 0; i < zeichen.length; i++) {
      const { z, s } = zeichen[i]!;
      if (z === " ") leer = i;
      breite += vorschub(z, !!s.fett);
      if (breite > max && leer > start) {
        aus.push(zuSegmenten(zeichen.slice(start, leer)));
        start = leer + 1;
        leer = -1;
        breite = zeichen.slice(start, i + 1).reduce((b, x) => b + vorschub(x.z, !!x.s.fett), 0);
      }
    }
    aus.push(zuSegmenten(zeichen.slice(start)));
  }
  return aus;
}
